import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const apiService = axios.create({
  baseURL: API_BASE_URL,
});

export const updateUserProfile = async (token, payload) => {
  try {
    const confiq = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await apiService.post(
      "/edit-user-profile",
      payload,
      confiq
    );
    return response.data;
  } catch (error) {}
};

export const logout =async(token)=>{
  try {
    const confiq = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await apiService.get('/logout',confiq)
    return response.data
  } catch (error) {
    
  }
}